import axios from 'axios'
import router from '@/router'
import { baseApi } from '@/config'
import { showLoading, hideLoading } from '@/utils/loading'
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: baseApi, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (!config.hideloading) {
      showLoading()
    }
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    hideLoading()
    const res = response.data
    if (res.code && res.code === 200) {
      return Promise.resolve(res)
    } else {
      if (res.code == 401) {
        Message.warning("请登录")
        localStorage.removeItem('token')
        // router.replace({ path: '/home', query: { auth: 'login' } })
      } else {
        Message.warning(res.msg)
      }
      return Promise.reject(res)
    }
    // if (res.code && res.code !== 200) {
    //   // 登录超时,重新登录
    //   if (res.code == 401) {
    //     localStorage.removeItem('token')
    //     router.replace({ path: '/' })
    //   } else {
    //     Toast(res.msg)
    //   }
    // } else {
    //   return Promise.resolve(res)
    // }
  },
  error => {
    hideLoading()
    // Toast("服务器繁忙，请稍后再试")
  }
)

export default service
